import { Box, Grid } from '@mui/material'
import { ImageField, List, usePermissions } from 'react-admin'

import config from './config'
import OrganisationFormLayout, { transformValues } from './form'
import AdvancedTextField from '../../components/AdvancedTextField'
import CompactList from '../../components/CompactList'
import FieldWrapper from '../../components/FieldWrapper'
import ReferenceLink from '../../components/ReferenceLink'
import { SYSTEM_PERMISSION_READ } from '../../config/permissions'
import { hasResourcePermission } from '../../domain/permissions'
import { AdvancedCreateButton } from '../common/create'
import { GenericListLayout, ListActions, ListDatagrid } from '../common/list'

const OrganisationsListLayout = () => {
  const { permissions } = usePermissions()
  return (
    <GenericListLayout
      compactListLayout={<CompactList linkType="show" image="picture" title="name" />}
      regularListLayout={
        <ListDatagrid>
          <FieldWrapper source="name">
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item boxSizing="content-box">
                <Box
                  width={36}
                  height={36}
                  p={0.5}
                  m={-0.5}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="white"
                >
                  <ImageField
                    sx={{ '& img': { display: 'block', width: '100% !important', margin: '0 !important' } }}
                    source="picture"
                    label={false}
                    sortable={false}
                  />
                </Box>
              </Grid>
              <Grid item>
                <AdvancedTextField source="name" />
              </Grid>
            </Grid>
          </FieldWrapper>
          <Grid container direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
            {config.options.references
              .filter((r) => hasResourcePermission(permissions, r, SYSTEM_PERMISSION_READ))
              .map((reference) => (
                <Grid key={reference} item>
                  <ReferenceLink reference={reference} />
                </Grid>
              ))}
          </Grid>
        </ListDatagrid>
      }
    />
  )
}

export default () => (
  <List
    empty={false}
    sort={config.options.defaultSort}
    filter={config.options.defaultFilterValues}
    actions={
      <ListActions>
        <AdvancedCreateButton transform={transformValues}>
          <OrganisationFormLayout />
        </AdvancedCreateButton>
      </ListActions>
    }
  >
    <OrganisationsListLayout />
  </List>
)
